import styles from './styles.module.scss';

export const Contact = () => (
  <div className={styles.contactWrapper}>
    <h1 className={styles.title}>Contact</h1>
    <p className={styles.subTitle}>お問い合わせ</p>
    <p>
      この度は、お手を煩わせてしまい大変申し訳ございません。
      下記よりメール・お電話でのお問い合わせを承っております。
      解消に向けて尽力いたしますので、ご連絡をいただけますと幸いでございます。
    </p>
    <div className={styles.contentWrapper}>
      <div className={styles.card}>
        <p className={styles.contentText}>メールでのお問い合わせ</p>
        <p className={styles.contentDescription}>
          下記のメールアドレスまで、送付いただけますと幸いでございます。
        </p>
        <p className={`${styles.contentText} ${styles.textCenter}`}>support@fukuri-app.jp</p>
      </div>
      <div className={styles.card}>
        <p className={styles.contentText}>お電話でのお問い合わせ</p>
        <p className={styles.contentDescription}>
          下記の電話番号までお掛けいただけますと幸いでございます。
        </p>
        <p className={`${styles.contentText} ${styles.textCenter}`}>03-4500-2643</p>
      </div>
    </div>
  </div>
);
